import {UIGameBaseDiceController} from '../../../../shared/scripts/ui_game/ui_game_dice/UIGameBaseDiceController'
import {UIGameBaseDiceView} from '../../../../shared/scripts/ui_game/ui_game_dice/UIGameBaseDiceView'

export class UIWGameBaseDiceController extends UIGameBaseDiceController {
    protected initializePlayerDiceView() {
        const canvas = this.uiGameManager.canvasController
        const x = canvas.appW - canvas.chatWidth - canvas.itemSize * 2.25
        const y = canvas.appH - canvas.itemSize * 2.75

        this.playerDiceView = new UIGameBaseDiceView(this.uiGameManager, this.isRedDiceActive, x, y, canvas.app.stage, canvas.itemSize, canvas.margin, (dice) => this.clickedDice(dice))
        this.playerDiceView.resetDice()
        this.playerDiceView.hide()
    }

    protected initializeOpponentDiceViews() {
        this.opponentDiceViews = []

        const canvas = this.uiGameManager.canvasController
        const playersController = this.uiGameManager.playersController
        const playerViewHeight = playersController.playerInformationViews[0].height
        const playerViewX = playersController.container.x
        const topOpponentViewY = playersController.container.y + this.uiGameManager.canvasController.margin

        const opponentDiceSize = this.uiGameManager.canvasController.itemSize * 0.6
        const spaceBetweenDice = this.uiGameManager.canvasController.margin
        const baseDiceY = topOpponentViewY + (playerViewHeight - opponentDiceSize) / 2 + this.uiGameManager.canvasController.margin
        const baseDiceX = playerViewX - (opponentDiceSize + this.uiGameManager.canvasController.margin) * 2
        const visibleOpponentViewCount = Math.floor(playersController.container.height / playersController.playerInformationViews[0].height) - 1

        for(let i = 0; i < visibleOpponentViewCount; i++) {
            const opponentDiceY = baseDiceY + i * (playerViewHeight + this.uiGameManager.canvasController.margin)
            const opponentDice = new UIGameBaseDiceView(this.uiGameManager, this.isRedDiceActive, baseDiceX, opponentDiceY, canvas.app.stage, opponentDiceSize, spaceBetweenDice, (dice) => this.clickedDice(dice), false)
            opponentDice.tintPassive()
            opponentDice.hide()
            this.opponentDiceViews.push(opponentDice)
        }
    }
}
